import { UseSetupCallbackCB, UserQuestionnaireType } from '@/components/decision-tree';
import { ROUTE_TESTING_PLAN } from '@/constants/routes';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useSetFooterIsVisible } from '@/queries/layout.queries';
import { useAnswerTestingQuestionnaire, useGetTestingQuestionnaire } from '@/queries/testing-plan.queries';
import { useToast } from '@cmpsr/components';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function useQuestionnaireController() {
  const { idTestOption } = useParams();
  const { data: userQuestionnaire } = useGetTestingQuestionnaire(idTestOption || '');
  const navigate = useNavigate();
  const uploadAnswerMutation = useAnswerTestingQuestionnaire();
  const mutateFooterIsVisible = useSetFooterIsVisible();
  const toast = useToast();

  useEffect(() => {
    mutateFooterIsVisible.mutateAsync(false);

    return () => {
      mutateFooterIsVisible.mutateAsync(true);
    };
  }, []);

  if (!idTestOption || !userQuestionnaire || !userQuestionnaire.questionnaire.answerScreeningId)
    return { userQuestionnaire: undefined, handleSaveQuestion: undefined };
  const { answerScreeningId } = userQuestionnaire.questionnaire;

  const handleSaveQuestion: UseSetupCallbackCB = async (
    surveyItemId,
    answer
  ): Promise<UserQuestionnaireType | null> => {
    try {
      const resultQuestionnaire = await uploadAnswerMutation.mutateAsync({ surveyItemId, answerScreeningId, answer });

      if (
        resultQuestionnaire.nextSurveyItem.surveyItemId === null ||
        resultQuestionnaire.nextSurveyItem.surveyItemId === 'summary'
      ) {
        navigate(ROUTE_TESTING_PLAN);
        return null;
      }

      return resultQuestionnaire;
    } catch (error: any) {
      console.error(error);
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: `Error ${error?.response?.data?.statusCode ?? ''}`,
        description: error?.response?.data?.message ?? error?.message,
        status: 'error',
      });

      return userQuestionnaire ?? null;
    }
  };

  return { userQuestionnaire, handleSaveQuestion };
}
